<template>
	<Layout :loading="loading || saving" :pageTitle="title" :backlink="`/products`">
		<template #cta>
			<div class="btn btn-primary" v-if="!saving" @click="$formulate.submit('form')">
				{{ title }}
			</div>
			<div class="btn btn-primary" v-if="saving">Guardando <span class="loader" /></div>

			<!-- <b-dropdown no-caret right class="dropdown-dots" v-if="action == 'update' && form">
				<template v-slot:button-content><i class="icon icon-dot-3"></i></template>
				<b-dropdown-item @click="deletePrompt(form)" class="delete-item"
					><i class="icon icon-trashcan"></i> Eliminar</b-dropdown-item
				>
			</b-dropdown> -->
		</template>

		<FormulateForm v-model="form" name="form" ref="formCategory" style="max-width:100%" @submit="save">
			<div class="main-container container" v-if="!loading">
				<div class="row row-xs mt-4">
					<div class="col-12 col-md-4">
						<div class="card ">
							<div class="card-body">
								<FormulateInput
									label="Imagen"
									name="image"
									type="file"
									accept="images"
									listStyle="thumb"
									:displayBlock="true"
									validation-name="Imagen"
									validation="required"
									:help="`La imagen debe ser de 400px x 400px con fondo transparente`"
								/>

								<FormulateInput class="mb-3" label="Categoría" name="category" :options="categories" type="select" validation="required" />

								<FormulateInput label="Nombre" name="name" validation-name="Nombre" validation="required" />

								<FormulateInput class="mt-3" name="salable" type="checkbox" label="Vendible?" help="El producto podrá ser vendido a traves de la web?" />

								<div class="row row-xs">
									<div class="col-6">
										<FormulateInput v-if="this.form.salable" class="mr-2" label="Precio" type="price" name="price" currency="U$S" validation-name="Precio" validation="required" />
									</div>
									<div class="col-6">
										<FormulateInput v-if="this.form.salable" class="mr-2" label="Stock" type="number" name="stock" validation-name="Stock" validation="required" />
									</div>
								</div>

								<FormulateInput class="mt-3" name="featured" type="checkbox" label="Destacado" help="Los productos destacados serán mostrados en el home de la web." />

								<FormulateInput
									label="Estado"
									name="status"
									type="select"
									:options="{
										ACTIVE: 'Activo',
										INACTIVE: 'Inactivo',
									}"
								/>
							</div>
						</div>
					</div>

					<div class="col-12 col-md-8">
						<div class="card ">
							<div class="card-body">
								<b-tabs content-class="mt-3">
									<b-tab title="Información">
										<div class="row row-xs">
											<div class="col-12 mt-3">
												<FormulateInput label="Intro" name="intro" validation-name="Intro" validation="required" type="textarea" />
											</div>

											<div class="col-12 mt-3">
												<FormulateInput type="wysiwyg" name="detail" height="200px" label="Descripción" :showMenuBar="false" />
											</div>

											<div class="col-12 mt-3">
												<FormulateInput label="Ficha técnica" name="dataSheet" type="file" accept="file" :displayBlock="true" :help="`Ficha técnica PDF`" />
											</div>
										</div>
									</b-tab>

									<b-tab title="Características">
										<div class="row row-xs">
											<div class="col-12 mt-3">
												<FormulateInput type="wysiwyg" name="equipment" height="200px" label="Equipamiento" :showMenuBar="false" />
											</div>
											<div class="col-12 mt-3">
												<FormulateInput type="wysiwyg" name="dimensions" height="200px" label="Dimensiones" :showMenuBar="false" />
											</div>
										</div>
									</b-tab>

									<b-tab title="Galería">
										<FormulateInput label="Imagen" name="gallery" type="file" accept="images" listStyle="thumb" :multiple="true" validation-name="Imagen" />

										<div class="text-center text-secondary ">Imagenes de 400px x 600px</div>

										
									</b-tab>
								</b-tabs>
							</div>
						</div>
					</div>
				</div>
			</div>
		</FormulateForm>
	</Layout>
</template>

<script>
import gql from 'graphql-tag'
import mixins from '@/mixins/mixins'
import formMixins from '@/mixins/formMixins'

export default {
	name: 'ProductForm',
	components: {

	},
	mixins: [mixins, formMixins],
	data() {
		return {
			title: 'Crear producto',
			action: 'create',
			btnAction: 'Crear producto',
			form: {
				category: null,
				image: null,
				gallery: [],
				dataSheet: null,
				slug: null,
				name: null,
				detailTitle: null,
				detail: null,
				salable: null,
				price: 0,
				stock: 0,
			},
			categories: [],
			loading: true,
			saving: false,
		}
	},

	async beforeMount() {
		await this.fetchData()
		this.loading = true
		// await this.fetchData()
		if (this.$route.params.id) {
			this.action = 'update'
			this.title = `Editar producto`
			this.btnAction = 'Guardar cambios'
			await this.load()
		}
		this.loading = false
	},

	methods: {
		imageCreated(data) {
			console.log('image created', data)
			this.form.images = data
		},
		imageUpdated(data) {
			console.log('image updated', data)
			// this.form.images.push(data)
		},
		imageDeleted(data) {
			console.log('image deleted', data)
			// this.form.images.push(data)
		},

		async save() {
			this.saving = true
			console.log('saving', this.form)
			let dataInput = {
				image: this.form.image ? this.form.image.id : null,
				category: this.form.category ? this.form.category : null,

				dataSheet: this.form.dataSheet ? this.form.dataSheet.id : null,
				name: this.form.name,
				detailTitle: this.form.detailTitle,
				intro: this.form.intro,
				detail: this.form.detail,
				equipment: this.form.equipment,
				dimensions: this.form.dimensions,
				salable: this.form.salable ? true : false,
				price: this.form.price ? parseFloat(this.form.price) : 0,
				stock: this.form.stock ? parseFloat(this.form.stock) : 0,

				featured: this.form.featured ? true : false,
				status: this.form.status,

				gallery: this.form.gallery.length > 0 ? this.form.gallery.map((i) => (i ? i.id : null)) : [],
			}

			if (this.action == 'create') {
				await this.create(dataInput)
			}
			if (this.action == 'update') {
				await this.update(dataInput)
			}
			this.saving = false
		},

		create(data) {
			return this.$apollo
				.mutate({
					mutation: gql`
						mutation($data: ProductInput!) {
							productCreate(data: $data) {
								id
							}
						}
					`,
					variables: {
						data,
					},
				})
				.then(() => {
					this.$toast.success('Producto creada correctamente')
					this.loading = false
					this.saving = false
					this.$router.go(-1)
				})
				.catch((error) => {
					this.parseGQLErrors(error)
					this.loading = false
				})
		},

		update(data) {
			return this.$apollo
				.mutate({
					mutation: gql`
						mutation($id: ID!, $data: ProductInput!) {
							productUpdate(id: $id, data: $data) {
								id
							}
						}
					`,
					variables: {
						id: this.$route.params.id,
						data,
					},
				})
				.then(() => {
					this.$toast.success('Producto editada correctamente')
					this.saving = false
					this.$router.go(-1)
				})
				.catch((error) => {
					this.errors = this.parseGQLErrors(error)
				})
		},

		load() {
			return this.$apollo
				.query({
					query: gql`
						query($id: ID!) {
							product(id: $id) {
								id
								name
								slug
								image {
									id
									type
									filename
									url
									urlThumb
								}
								dataSheet {
									id
									type
									filename
									url
									urlThumb
								}
								imageMain {
									id
									type
									filename
									url
									urlThumb
								}
								gallery {
									id
									type
									filename
									url
									urlThumb
								}
								category {
									id
									title
								}
								detailTitle
								intro
								detail
								equipment
								dimensions
								featured
								salable
								price
								stock
								status
								statusText
								statusClass
							}
						}
					`,
					variables: { id: this.$route.params.id },
					fetchPolicy: 'network-only',
				})
				.then(({ data }) => {
					this.form = data.product
					if (data.product.category) this.form.category = data.product.category.id
				})
				.catch(() => {
					this.$toast.success('El item que desea editar no existe')
					this.$router.go(-1)
				})
		},

		fetchData() {
			return this.$apollo
				.query({
					query: gql`
						query {
							categories {
								data {
									id
									title
								}
							}
						}
					`,
					fetchPolicy: 'network-only',
				})
				.then(({ data }) => {
					this.categories = []
					for (const item of data.categories.data) {
						this.categories.push({ value: item.id, label: item.title })
					}
				})
		},

		deletePrompt(item) {
			this.$dialog
				.confirm(
					{
						title: 'Eliminar producto',
						body: `¿Está seguro que desea eliminar la producto "<strong>${item.name}"</strong>?`,
					},
					{
						okText: 'Eliminar',
						customClass: 'delete-prompt',
					}
				)
				.then(() => {
					this.delete(item)
				})
		},

		delete(item) {
			item.loading = true
			this.$apollo
				.mutate({
					mutation: gql`
						mutation($id: ID!) {
							productDelete(id: $id) {
								id
							}
						}
					`,
					variables: {
						id: item.id,
					},
				})
				.then(() => {
					this.$toast.success('Producto eliminado correctamente')
					this.load()
				})
				.catch((error) => {
					this.errors = this.parseGQLErrors(error)
					item.loading = false
				})
		},
	},
}
</script>
